import { gql } from '@apollo/client';
import { REPORTING_REQUIREMENT_DETAIL } from '../fragments/reportingRequirement';

export const ARCHIVE_REPORTING_REQUIREMENT = gql`
  mutation archiveReportingRequirement($id: ID!) {
    requirement: archiveReportingRequirement(id: $id) {
      ...reportingRequirementDetail
    }
  }
  ${REPORTING_REQUIREMENT_DETAIL}
`;
